"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = ShareButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _Share = _interopRequireDefault(require("./Share"));
function ShareButton(props) {
  var className = props.className,
    children = props.children,
    rest = (0, _objectWithoutPropertiesLoose2["default"])(props, ["className", "children"]);
  return _react["default"].createElement(_Share["default"], rest, function (_ref) {
    var loading = _ref.loading,
      handleClick = _ref.handleClick;
    return _react["default"].createElement("button", {
      type: "button",
      disabled: loading,
      className: className,
      onClick: handleClick
    }, children);
  });
}
ShareButton.defaultProps = (0, _extends2["default"])({}, _Share["default"].defaultProps, {
  className: undefined
});
//# sourceMappingURL=ShareButton.js.map
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-facebook/lib/ShareButton.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-facebook/lib/ShareButton.js");
  }
}();